export const mockAiTasks = [
  {
    id: 'ai1',
    type: 'titulo',
    articleTitle: 'Prefeitura anuncia novo plano de mobilidade urbana',
    status: 'concluido',
    confidence: 94,
    original: 'Prefeitura anuncia novo plano de mobilidade urbana para 2026',
    suggestion: 'Cidade investe R$ 2,4 bi em revolução do transporte público até 2028',
    createdAt: '2026-04-07T08:15:00Z',
    duration: '2.3s',
  },
  {
    id: 'ai2',
    type: 'resumo',
    articleTitle: 'Seleção brasileira convoca 26 jogadores',
    status: 'processando',
    confidence: 0,
    original: '',
    suggestion: '',
    createdAt: '2026-04-07T09:00:00Z',
    duration: null,
    progress: 67,
  },
  {
    id: 'ai3',
    type: 'classificacao',
    articleTitle: 'Festival de Cinema de Jardel City bate recorde',
    status: 'pendente_revisao',
    confidence: 88,
    original: 'Seção: Entretenimento',
    suggestion: 'Seção: Cultura | Posição: Página 5 | Destaque: Médio',
    createdAt: '2026-04-07T07:45:00Z',
    duration: '1.8s',
  },
  {
    id: 'ai4',
    type: 'imagem',
    articleTitle: 'Startup local levanta R$ 15 milhões',
    status: 'pendente_revisao',
    confidence: 76,
    original: 'Sem imagem',
    suggestion: 'https://public.readdy.ai/ai/img_res/e35bb085ad85ec8fb1d6472ea115fc99.jpg',
    createdAt: '2026-04-07T08:30:00Z',
    duration: '4.1s',
  },
  {
    id: 'ai5',
    type: 'layout',
    articleTitle: 'Edição 14820 - Página 1',
    status: 'processando',
    confidence: 0,
    original: '',
    suggestion: '',
    createdAt: '2026-04-07T09:05:00Z',
    duration: null,
    progress: 23,
  },
  {
    id: 'ai6',
    type: 'titulo',
    articleTitle: 'Pesquisadores descobrem nova espécie de orquídea',
    status: 'aprovado',
    confidence: 91,
    original: 'Pesquisadores descobrem nova espécie de orquídea na Mata Atlântica',
    suggestion: 'Cientistas identificam orquídea inédita na Serra do Mar de Jardel City',
    createdAt: '2026-04-06T16:20:00Z',
    duration: '2.1s',
  },
];

export const mockAiStats = {
  totalProcessed: 1247,
  todayProcessed: 34,
  pendingReview: 8,
  avgConfidence: 87,
  activeNow: 2,
};
